<template>
  <ion-page>
    <ion-tabs>
      <ion-router-outlet></ion-router-outlet>
      <ion-tab-bar slot="bottom" class="nc-tab-bar">
        <ion-tab-button :class="($route.name == 'inspections-list') ? 'nc-tab-active' : ''" tab="inspections"
          @click="$router.replace('/root/inspections')">
          <mdicon name="account-hard-hat-outline" />
          <span class="nc-tab-label">Inspecties</span>
        </ion-tab-button>

        <ion-tab-button :class="$route.name == 'settings' ? 'nc-tab-active' : ''" tab="settings" href="/root/settings">
          <mdicon name="cog-outline" />
          <span class="nc-tab-label">Instellingen</span>
        </ion-tab-button>
      </ion-tab-bar>
    </ion-tabs>
  </ion-page>
</template>

<script lang="js">
import { IonTabBar, IonTabButton, IonTabs, IonPage, IonRouterOutlet } from '@ionic/vue';

export default {
  name: 'TabsPage',
  components: { IonTabs, IonTabBar, IonTabButton, IonPage, IonRouterOutlet },
};
</script>

<style>
.nc-tab-bar {
  --background: var(--nc-bg);
  --border: none;
  border-top: 1px solid var(--nc-border);
  padding-top: 4px;
  padding-bottom: calc(4px + var(--nc-safe-area-bottom, env(safe-area-inset-bottom, 0px)));
  height: calc(56px + var(--nc-safe-area-bottom, env(safe-area-inset-bottom, 0px)));
}

.nc-tab-bar ion-tab-button {
  --color: var(--nc-text-muted);
  --color-selected: var(--nc-color-primary);
  font-family: var(--nc-font-family);
}

.nc-tab-label {
  font-size: 12px;
  font-family: var(--nc-font-family);
}

.nc-tab-active {
  --color: var(--nc-color-primary);
  color: var(--nc-color-primary);
}
</style>
